(function() {
	'use strict';
	window.dataLayer = window.dataLayer || [];
	var CFG = window.SkAnalyticsData || {};
	var ZEME = CFG.countryCode || '';
	var MENA = CFG.currency || 'CZK';
	var VERTICAL = 'retail';function cislo(x) { var n = Number(x); return Number.isFinite(n) ? n : 0; }
	function zaokr(x) { return +(cislo(x).toFixed(2)); }function polozka(it, index) {
		var pid = String(it.product_id != null ? it.product_id : '');
		var vid = String(it.variant_id != null ? it.variant_id : '');
		var o = {
			index: index,
			item_id: 'shopify_' + ZEME + '_' + pid + '_' + vid,
			product_id: pid,
			variant_id: vid,
			item_name: it.product_title || '',
			quantity: cislo(it.quantity) || 1,
			price: zaokr(cislo(it.final_price) / 100),
			discount: it.total_discount ? zaokr(cislo(it.total_discount) / 100) : 0
		};
		if(it.product_type) o.item_category = it.product_type;
		if(it.vendor) o.item_brand = /skinners/i.test(it.vendor) ? 'Skinners' : it.vendor;   // vendor = full company name since 16. 10. 2026, the brand stays Skinners
		if(it.variant_title && it.variant_title !== 'Default Title') o.item_variant = it.variant_title;
		if(it.sku) o.sku = it.sku;
		if(it.item_list_name) o.item_list_name = it.item_list_name;
		if(it.item_list_id) o.item_list_id = String(it.item_list_id);
		return o;
	}

	function push(event, data) {
		if(!data || !Array.isArray(data.items) || data.items.length === 0) return;
		dataLayer.push({ecommerce: null});
		var polozky = data.items.map(polozka);
		var d = {event: event, ecommerce: {currency: data.currency || MENA, items: polozky}};
		d.ecommerce.value = data.total_price !== undefined
			? zaokr(cislo(data.total_price) / 100)
			: zaokr(polozky.reduce(function(s, i) { return s + i.price * i.quantity; }, 0));
		if(data.item_list_id) d.ecommerce.item_list_id = data.item_list_id;
		if(data.item_list_name) d.ecommerce.item_list_name = data.item_list_name;
		if(data.search_term) d.search_term = data.search_term;
		dataLayer.push({dynamicRemarketing: null});
		d.dynamicRemarketing = {
			value: d.ecommerce.value,
			items: polozky.map(function(i) { return {id: i.item_id, google_business_vertical: VERTICAL}; })
		};
		dataLayer.push(d);
	}var api = {
		viewItem: function(d) { push('view_item', d); },
		addToCart: function(d) { push('add_to_cart', d); },
		removeFromCart: function(d) { push('remove_from_cart', d); },
		viewCart: function(d) { push('view_cart', d); },
		beginCheckout: function(d) { push('begin_checkout', d); },
		viewItemList: function(d) { push('view_item_list', d); },
		event: function(name, payload) { dataLayer.push(Object.assign({event: name}, payload || {})); }
	};
	window.skTrack = api;if(CFG.customer) dataLayer.push({customer: CFG.customer});if(CFG.product && CFG.product.items) api.viewItem(CFG.product);
	document.addEventListener('sk:product-changed', function(e) {
		if(e && e.detail && e.detail.items) api.viewItem(e.detail);
	});var stavKosiku = null;
	var bezi = false;
	var cekaZnovu = false;
	function mapaKosiku(cart) {
		var m = new Map();
		((cart && cart.items) || []).forEach(function(i) { m.set(String(i.key || i.variant_id), i); });
		return m;
	}
	async function synchronizujKosik(prvni) {
		if(bezi) { cekaZnovu = true; return; }
		bezi = true;
		try {
			var r = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {headers: {'Accept': 'application/json'}});
			if(!r.ok) return;
			var cart = await r.json();
			var novy = mapaKosiku(cart);
			if(!prvni && stavKosiku) {
				var pridane = [], odebrane = [];
				novy.forEach(function(it, k) {
					var stary = stavKosiku.get(k);
					var rozdil = it.quantity - (stary ? stary.quantity : 0);
					if(rozdil > 0) pridane.push(Object.assign({}, it, {quantity: rozdil}));
					else if(rozdil < 0) odebrane.push(Object.assign({}, it, {quantity: -rozdil}));
				});
				stavKosiku.forEach(function(it, k) {
					if(!novy.has(k)) odebrane.push(Object.assign({}, it));
				});
				if(pridane.length) api.addToCart({items: pridane, currency: cart.currency});
				if(odebrane.length) api.removeFromCart({items: odebrane, currency: cart.currency});
			}
			stavKosiku = novy;
			window.__skCart = cart;
		} catch(e) {console.warn('[sk-analytics] cart.js', e && e.message);
		} finally {
			bezi = false;
			if(cekaZnovu) { cekaZnovu = false; synchronizujKosik(false); }
		}
	}
	synchronizujKosik(true);
	window.addEventListener('cart:refresh', function() { synchronizujKosik(false); });var kosikPoslan = false;
	document.addEventListener('click', function(e) {
		var ic = e.target.closest('a[href$="/cart"], a[href*="/cart?"], .sh-icon[aria-label], [data-cart-open]');
		if(!ic) return;
		if(ic.classList && ic.classList.contains('sh-icon') && !/cart/i.test(ic.getAttribute('href') || '')) return;
		if(kosikPoslan) return;
		kosikPoslan = true;
		setTimeout(function() { kosikPoslan = false; }, 1500);
		var c = window.__skCart;
		if(c && c.items && c.items.length) api.viewCart({items: c.items, total_price: c.total_price, currency: c.currency});
	}, true);document.addEventListener('submit', function(e) {
		var f = e.target.closest('form[action^="/contact"]');
		if(!f) return;
		var d = {form_location: window.location.href, form_id: f.getAttribute('id'), form_classes: f.getAttribute('class')};
		var typ = f.querySelector('input[name="form_type"]');
		f.querySelectorAll('input:not([type=hidden]):not([type=submit]), textarea, select').forEach(function(inp) {
			if(!inp.name || !inp.value) return;
			var m = inp.name.match(/\[(.*?)\]/);
			if(m && m.length > 1) d[m[1]] = inp.value;
		});
		if(typ && typ.value === 'customer') dataLayer.push(Object.assign({event: 'newsletter_signup'}, d));
		else if(typ && typ.value === 'contact') dataLayer.push(Object.assign({event: 'contact_form_submit'}, d));
	});
	document.addEventListener('click', function(e) {
		var tel = e.target.closest('a[href^="tel:"]');
		if(tel) {
			dataLayer.push({event: 'phone_number_click', page_location: window.location.href,
				link_classes: tel.getAttribute('class'), link_id: tel.getAttribute('id'),
				phone_number: tel.getAttribute('href').replace('tel:', '')});
		}
		var mail = e.target.closest('a[href^="mailto:"]');
		if(mail) {
			dataLayer.push({event: 'email_click', page_location: window.location.href,
				link_classes: mail.getAttribute('class'), link_id: mail.getAttribute('id'),
				email_address: mail.getAttribute('href').replace('mailto:', '')});
		}
	});var checkoutPoslan = false;
	function checkoutTrefa(t) {
		if(!t || !t.closest) return false;
		return !!t.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-checkout]');
	}
	document.addEventListener('pointerdown', function(e) {
		if(!checkoutTrefa(e.target) || checkoutPoslan) return;
		checkoutPoslan = true;
		var c = window.__skCart;
		if(c && c.items && c.items.length) api.beginCheckout({items: c.items, total_price: c.total_price, currency: c.currency});
	}, true);
	document.addEventListener('submit', function(e) {
		var f = e.target;
		if(!f || checkoutPoslan) return;
		if(!/\/(cart|checkout)/.test(f.getAttribute('action') || '')) return;
		checkoutPoslan = true;
		var c = window.__skCart;
		if(c && c.items && c.items.length) api.beginCheckout({items: c.items, total_price: c.total_price, currency: c.currency});
	}, true);
})();
